/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Kies_DagenInputs */

const nl_planning_vakanties_kies_dagen = /** @type {(inputs: Planning_Vakanties_Kies_DagenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies dag(en)`)
};

/**

* @param {Planning_Vakanties_Kies_DagenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_kies_dagen = /** @type {((inputs?: Planning_Vakanties_Kies_DagenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Kies_DagenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_kies_dagen(inputs)
});
export { planning_vakanties_kies_dagen as "planning.vakanties.kies_dagen" }